import { PolarArea } from 'vue-chartjs'

export default {
  name: 'polar-chart',
  mixins: [PolarArea]
}
